
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import {CanserModel} from '../models/CanserModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class CanserService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }


public getCancer(cancerid: string , comCode: string) {
  let params = new HttpParams();
    params = params.append("CancerID", cancerid);
    params = params.append("compCode", comCode);
    const options = {
        params: params
    };
    return this.http.get<CanserModel>(this.urlsconfig.WebAPIURL_Test + 'api/Cancers/GetCancer',options);
}


public getCancerLookupTop() {

    return this.http.get<CanserModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Cancers/CancersLookupTop');
}
public getCancerDetLookupTop(cancerid: string , compCode: string) {

let params = new HttpParams();
    params = params.append("cantype", cancerid);
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<CanserModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Cancers/CancersDetLookupTop',options);
}
public getCancerSub(cancerid: string ,canserial: string , compCode: string) {

let params = new HttpParams();
    params = params.append("cantype", cancerid);
    params = params.append("canserial", canserial);
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<CanserModel>(this.urlsconfig.WebAPIURL_Test + 'api/Cancers/GetCancerSub',options);
}
}
